import React, { useState, useEffect, useRef } from "react";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDoP6DT1fKz1ENNIWncYRTx303Q6UIS2e4",
  authDomain: "for-me-outlet-4235d.firebaseapp.com",
  projectId: "for-me-outlet-4235d",
  storageBucket: "for-me-outlet-4235d.firebasestorage.app",
  messagingSenderId: "558029289540",
  appId: "1:558029289540:web:17a37689eb3ed2d87ea411",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const CLOUDINARY_CLOUD = "dqcsbypu3";
const CLOUDINARY_PRESET = "zfydpvpp";

const uploadToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_PRESET);
  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/image/upload`,
    { method: "POST", body: formData }
  );
  const data = await res.json();
  return data.secure_url;
};

const CLOTH_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
const SHOE_SIZES = ["34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46"];

const styles = {
  root: {
    fontFamily: "'Segoe UI', sans-serif",
    background: "#0f0f0f",
    color: "#f0f0f0",
    minHeight: "100vh",
  },
  navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    height: 60,
    background: "#1a1a1a",
    borderBottom: "1px solid #2a2a2a",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  logo: {
    fontSize: 20,
    fontWeight: 700,
    color: "#02008f",
    letterSpacing: 1,
  },
  navBtn: {
    background: "none",
    border: "none",
    color: "#f0f0f0",
    cursor: "pointer",
    padding: "8px 10px",
    borderRadius: 8,
    fontSize: 20,
    position: "relative",
    transition: "background 0.2s",
  },
  badge: {
    position: "absolute",
    top: 2,
    right: 2,
    background: "#0026ff",
    color: "#fff",
    borderRadius: "50%",
    width: 16,
    height: 16,
    fontSize: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
  },
  main: { maxWidth: 1200, margin: "0 auto", padding: "24px 16px" },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: 24,
  },
  card: {
    background: "#1a1a1a",
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid #2a2a2a",
    cursor: "pointer",
    transition: "transform 0.2s",
  },
  cardImg: {
    width: "100%",
    height: 220,
    objectFit: "cover",
    background: "#222",
  },
  cardBody: { padding: 14 },
  cardTitle: { fontSize: 15, fontWeight: 600, marginBottom: 4 },
  cardPrice: { color: "#0026ff", fontWeight: 700, fontSize: 17 },
  oldPrice: {
    textDecoration: "line-through",
    color: "#666",
    fontSize: 13,
    marginRight: 6,
  },
  badge2: {
    background: "#0026ff",
    color: "#fff",
    borderRadius: 4,
    padding: "2px 6px",
    fontSize: 11,
    fontWeight: 700,
    marginLeft: 6,
  },
  btn: {
    background: "#0026ff",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "10px 20px",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 14,
    transition: "opacity 0.2s",
  },
  btnOutline: {
    background: "none",
    color: "#0026ff",
    border: "1px solid #0026ff",
    borderRadius: 8,
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },
  btnDanger: {
    background: "#c0392b",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    background: "#222",
    border: "1px solid #333",
    borderRadius: 8,
    color: "#f0f0f0",
    fontSize: 14,
    boxSizing: "border-box",
  },
  modal: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 200,
    padding: 16,
  },
  modalBox: {
    background: "#1a1a1a",
    borderRadius: 16,
    padding: 28,
    width: "100%",
    maxWidth: 500,
    maxHeight: "90vh",
    overflowY: "auto",
    border: "1px solid #2a2a2a",
  },
  label: { display: "block", marginBottom: 6, color: "#aaa", fontSize: 13 },
  formGroup: { marginBottom: 16 },
  sizeBtn: {
    padding: "6px 12px",
    borderRadius: 6,
    border: "1px solid #333",
    background: "#222",
    color: "#f0f0f0",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    margin: "2px",
    transition: "all 0.2s",
  },
  sizeBtnActive: {
    background: "#0026ff",
    borderColor: "#0026ff",
    color: "#fff",
  },
  footer: {
    background: "#1a1a1a",
    borderTop: "1px solid #2a2a2a",
    padding: "32px 24px",
    textAlign: "center",
    color: "#666",
    fontSize: 14,
    marginTop: 60,
  },
};

function Tooltip({ text, children }) {
  const [show, setShow] = useState(false);
  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div
          style={{
            position: "absolute",
            bottom: "110%",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "#fff",
            padding: "4px 10px",
            borderRadius: 6,
            fontSize: 12,
            whiteSpace: "nowrap",
            pointerEvents: "none",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [cart, setCart] = useState([]);
  const [view, setView] = useState("shop");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showCart, setShowCart] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [sortBy, setSortBy] = useState("default");
  const [filterCat, setFilterCat] = useState("toate");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [authTab, setAuthTab] = useState("login");
  const [regEmail, setRegEmail] = useState("");
  const [regPass, setRegPass] = useState("");
  const [regName, setRegName] = useState("");
  const [regErr, setRegErr] = useState("");
  const [regSuccess, setRegSuccess] = useState(false);
  const [orderForm, setOrderForm] = useState({ nume: "", telefon: "", email: "", adresa: "" });
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const [selectedSize, setSelectedSize] = useState("");
  const notifiedOrders = useRef(new Set());

  useEffect(() => {
    if (window.location.hash === "#admin") setShowLogin(true);
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      setUser(u);
      setIsAdmin(!!u);
    });
  }, []);

  useEffect(() => {
    const q = query(collection(db, "produse"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setProducts(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (!isAdmin) return;
    const q = query(collection(db, "comenzi"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      const newOrders = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      newOrders.forEach((o) => {
        if (!notifiedOrders.current.has(o.id)) {
          notifiedOrders.current.add(o.id);
          if (Notification.permission === "granted") {
            new Notification("Comandă nouă For Me Outlet!", { body: `${o.nume} - ${o.produs}` });
          }
        }
      });
      setOrders(newOrders);
    });
    if (Notification.permission === "default") Notification.requestPermission();
    return unsub;
  }, [isAdmin]);

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, loginEmail, loginPass);
      setShowLogin(false);
      setLoginErr("");
      setView("admin");
    } catch {
      setLoginErr("Email sau parolă greșită.");
    }
  };

  const register = async () => {
    if (!regEmail || !regPass || !regName) { setRegErr("Completează toate câmpurile."); return; }
    try {
      const cred = await createUserWithEmailAndPassword(auth, regEmail, regPass);
      await setDoc(doc(db, "users", cred.user.uid), {
        email: regEmail, nume: regName, role: "pending", createdAt: new Date(),
      });
      await signOut(auth);
      setRegSuccess(true);
      setRegErr("");
    } catch (e) {
      setRegErr(e.message || "Eroare la înregistrare.");
    }
  };

  const logout = async () => { await signOut(auth); setIsAdmin(false); setView("shop"); };

  const addToCart = (product, size) => {
    setCart((prev) => {
      const exists = prev.find((i) => i.id === product.id && i.size === size);
      if (exists) return prev.map((i) => i.id === product.id && i.size === size ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { ...product, size, qty: 1 }];
    });
    setShowCart(true);
  };

  const removeFromCart = (id, size) => setCart((prev) => prev.filter((i) => !(i.id === id && i.size === size)));

  const placeOrder = async () => {
    if (!orderForm.nume || !orderForm.telefon || !orderForm.adresa) return;
    for (const item of cart) {
      await addDoc(collection(db, "comenzi"), {
        ...orderForm, produs: item.nume, marime: item.size || "",
        cantitate: item.qty, pret: item.pretRedus || item.pret,
        createdAt: new Date(), status: "nou",
      });
    }
    setCart([]);
    setOrderSuccess(true);
    setShowOrder(false);
    setTimeout(() => setOrderSuccess(false), 4000);
  };

  const deleteOrder = async (id) => await deleteDoc(doc(db, "comenzi", id));
  const deleteProduct = async (id) => { if (window.confirm("Ștergi produsul?")) await deleteDoc(doc(db, "produse", id)); };

  const totalCart = cart.reduce((s, i) => s + (i.pretRedus || i.pret) * i.qty, 0);
  const categories = ["toate", ...new Set(products.map((p) => p.categorie).filter(Boolean))];
  const filteredProducts = products
    .filter((p) => filterCat === "toate" || p.categorie === filterCat)
    .sort((a, b) => {
      if (sortBy === "pret-asc") return (a.pretRedus || a.pret) - (b.pretRedus || b.pret);
      if (sortBy === "pret-desc") return (b.pretRedus || b.pret) - (a.pretRedus || a.pret);
      if (sortBy === "nume") return a.nume.localeCompare(b.nume);
      return 0;
    });

  return (
    <div style={styles.root}>
      {/* NAVBAR */}
      <nav style={styles.navbar}>
        <span style={styles.logo}>For Me Outlet</span>
        <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
          <Tooltip text="Acasă"><button style={styles.navBtn} onClick={() => setView("shop")}>🏠</button></Tooltip>
          <Tooltip text="Coș">
            <button style={styles.navBtn} onClick={() => setShowCart(true)}>
              🛍️{cart.length > 0 && <span style={styles.badge}>{cart.length}</span>}
            </button>
          </Tooltip>
          {isAdmin && (
            <>
              <Tooltip text="Comenzi">
                <button style={styles.navBtn} onClick={() => setView("admin")}>
                  📋{orders.filter((o) => o.status === "nou").length > 0 && <span style={styles.badge}>{orders.filter((o) => o.status === "nou").length}</span>}
                </button>
              </Tooltip>
              <Tooltip text="Adaugă produs"><button style={styles.navBtn} onClick={() => setShowAddProduct(true)}>➕</button></Tooltip>
              <Tooltip text="Deconectare"><button style={styles.navBtn} onClick={logout}>🚪</button></Tooltip>
            </>
          )}
          <div style={{ position: "relative" }} onMouseEnter={() => setShowContact(true)} onMouseLeave={() => setShowContact(false)}>
            <Tooltip text="Contact"><button style={styles.navBtn}>📞</button></Tooltip>
            {showContact && (
              <div style={{ position: "absolute", right: 0, top: "100%", background: "#222", border: "1px solid #333", borderRadius: 10, padding: 16, minWidth: 200, zIndex: 300 }}>
                <div style={{ marginBottom: 8 }}>📞 +373079797904 </div>
                <div style={{ marginBottom: 8 }}>✉️ formeoutlet8@gmail.com</div>
                <div>📍 strada Miron Costin 2 a, Orhei</div>
                <div style={{ marginTop: 8 }}>🕐 Luni-Sâm: 08:00 - 17:00</div>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* SHOP */}
      {view === "shop" && (
        <div style={styles.main}>
          {orderSuccess && (
            <div style={{ background: "#1a3a1a", border: "1px solid #2a6a2a", borderRadius: 10, padding: 16, marginBottom: 24, color: "#4caf50", textAlign: "center" }}>
              ✅ Comanda a fost plasată cu succes! Vă vom contacta în curând.
            </div>
          )}
          <div style={{ display: "flex", gap: 12, marginBottom: 24, flexWrap: "wrap" }}>
            <select style={{ ...styles.input, width: "auto" }} value={filterCat} onChange={(e) => setFilterCat(e.target.value)}>
              {categories.map((c) => <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>)}
            </select>
            <select style={{ ...styles.input, width: "auto" }} value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="default">Sortare implicită</option>
              <option value="pret-asc">Preț crescător</option>
              <option value="pret-desc">Preț descrescător</option>
              <option value="nume">Nume A-Z</option>
            </select>
          </div>
          <div style={styles.grid}>
            {filteredProducts.map((p) => {
              const imgs = Array.isArray(p.imagini) ? p.imagini : [];
              return (
                <div key={p.id} style={styles.card} onClick={() => { setSelectedProduct(p); setImgIndex(0); setSelectedSize(""); }}>
                  {imgs[0] ? <img src={imgs[0]} alt={p.nume} style={styles.cardImg} /> : <div style={{ ...styles.cardImg, display: "flex", alignItems: "center", justifyContent: "center", color: "#444" }}>👗</div>}
                  <div style={styles.cardBody}>
                    {p.categorie && <div style={{ fontSize: 11, color: "#0026ff", marginBottom: 4, textTransform: "uppercase" }}>{p.categorie}</div>}
                    <div style={styles.cardTitle}>{p.nume}</div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {p.pretRedus ? (<><span style={styles.oldPrice}>{p.pret} MDL</span><span style={styles.cardPrice}>{p.pretRedus} MDL</span><span style={styles.badge2}>REDUCERE</span></>) : <span style={styles.cardPrice}>{p.pret} MDL</span>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ADMIN */}
      {view === "admin" && isAdmin && (
        <div style={styles.main}>
          <h2 style={{ marginBottom: 24 }}>📋 Comenzi</h2>
          {orders.length === 0 && <p style={{ color: "#666" }}>Nu există comenzi.</p>}
          {orders.map((o) => (
            <div key={o.id} style={{ background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: 12, padding: 20, marginBottom: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16 }}>{o.produs} {o.marime && <span style={{ background: "#0026ff", color: "#fff", borderRadius: 4, padding: "2px 8px", fontSize: 12, marginLeft: 8 }}>{o.marime}</span>}</div>
                  <div style={{ color: "#aaa", fontSize: 14, marginTop: 4 }}>👤 {o.nume} | 📞 {o.telefon} | ✉️ {o.email}</div>
                  <div style={{ color: "#aaa", fontSize: 14 }}>📍 {o.adresa} | Qty: {o.cantitate} | 💰 {o.pret * o.cantitate} MDL</div>
                  <div style={{ color: "#666", fontSize: 12, marginTop: 4 }}>{o.createdAt?.toDate?.()?.toLocaleString("ro-RO") || ""}</div>
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "start" }}>
                  <select style={{ ...styles.input, width: "auto", fontSize: 13 }} value={o.status} onChange={async (e) => { await updateDoc(doc(db, "comenzi", o.id), { status: e.target.value }); }}>
                    <option value="nou">Nou</option>
                    <option value="in-procesare">În procesare</option>
                    <option value="livrat">Livrat</option>
                    <option value="anulat">Anulat</option>
                  </select>
                  <button style={styles.btnDanger} onClick={() => deleteOrder(o.id)}>🗑️</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* PRODUCT MODAL */}
      {selectedProduct && (
        <div style={styles.modal} onClick={(e) => { if (e.target === e.currentTarget) setSelectedProduct(null); }}>
          <div style={{ ...styles.modalBox, maxWidth: 640 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
              <h2 style={{ margin: 0 }}>{selectedProduct.nume}</h2>
              <button style={{ ...styles.navBtn, fontSize: 18 }} onClick={() => setSelectedProduct(null)}>✕</button>
            </div>
            {Array.isArray(selectedProduct.imagini) && selectedProduct.imagini.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <img src={selectedProduct.imagini[imgIndex]} alt="" style={{ width: "100%", height: 280, objectFit: "cover", borderRadius: 10 }} />
                {selectedProduct.imagini.length > 1 && (
                  <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                    {selectedProduct.imagini.map((img, i) => (
                      <img key={i} src={img} alt="" onClick={() => setImgIndex(i)} style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6, cursor: "pointer", border: imgIndex === i ? "2px solid #0026ff" : "2px solid transparent" }} />
                    ))}
                  </div>
                )}
              </div>
            )}
            {selectedProduct.descriere && <p style={{ color: "#bbb", marginBottom: 16 }}>{selectedProduct.descriere}</p>}
            <div style={{ marginBottom: 16 }}>
              {selectedProduct.pretRedus ? (<><span style={styles.oldPrice}>{selectedProduct.pret} MDL</span><span style={{ ...styles.cardPrice, fontSize: 22 }}>{selectedProduct.pretRedus} MDL</span><span style={styles.badge2}>REDUCERE</span></>) : <span style={{ ...styles.cardPrice, fontSize: 22 }}>{selectedProduct.pret} MDL</span>}
            </div>
            {selectedProduct.marimi && selectedProduct.marimi.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 13, color: "#aaa", marginBottom: 8 }}>Mărime:</div>
                <div>
                  {selectedProduct.marimi.map((m) => (
                    <button key={m} style={{ ...styles.sizeBtn, ...(selectedSize === m ? styles.sizeBtnActive : {}) }} onClick={() => setSelectedSize(m)}>{m}</button>
                  ))}
                </div>
              </div>
            )}
{selectedProduct.culori && (
  <div style={{ marginBottom: 16 }}>
    <div style={{ fontSize: 13, color: "#aaa", marginBottom: 8 }}>Culoare:</div>
    <div>
      {selectedProduct.culori.split(",").filter(Boolean).map((c, i) => (
        <span key={i} style={{
          display: "inline-block", width: 28, height: 28, borderRadius: "50%", margin: "0 4px",
          background: c.includes("|") ? `linear-gradient(90deg,${c.split("|")[0]} 50%,${c.split("|")[1]} 50%)` : c,
          border: "2px solid #555",
        }} />
      ))}
    </div>
  </div>
)}
            <div style={{ display: "flex", gap: 12 }}>
              <button style={styles.btn} onClick={() => { addToCart(selectedProduct, selectedSize); setSelectedProduct(null); }}>🛍️ Adaugă în coș</button>
              {isAdmin && (
                <>
                  <button style={styles.btnOutline} onClick={() => { setEditProduct(selectedProduct); setSelectedProduct(null); setShowAddProduct(true); }}>✏️ Editează</button>
                  <button style={styles.btnDanger} onClick={() => { deleteProduct(selectedProduct.id); setSelectedProduct(null); }}>🗑️</button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* CART MODAL */}
      {showCart && (
        <div style={styles.modal} onClick={(e) => { if (e.target === e.currentTarget) setShowCart(false); }}>
          <div style={styles.modalBox}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
              <h2 style={{ margin: 0 }}>🛍️ Coșul meu</h2>
              <button style={{ ...styles.navBtn, fontSize: 18 }} onClick={() => setShowCart(false)}>✕</button>
            </div>
            {cart.length === 0 ? <p style={{ color: "#666" }}>Coșul este gol.</p> : (
              <>
                {cart.map((item, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #2a2a2a" }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>{item.nume}</div>
                      <div style={{ fontSize: 13, color: "#aaa" }}>
                        {item.size && <span style={{ background: "#0026ff", color: "#fff", borderRadius: 4, padding: "1px 6px", fontSize: 11, marginRight: 6 }}>{item.size}</span>}
                        Qty: {item.qty} × {item.pretRedus || item.pret} MDL
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      <span style={{ color: "#0026ff", fontWeight: 700 }}>{(item.pretRedus || item.pret) * item.qty} MDL</span>
                      <button style={{ background: "none", border: "none", color: "#c0392b", cursor: "pointer", fontSize: 18 }} onClick={() => removeFromCart(item.id, item.size)}>✕</button>
                    </div>
                  </div>
                ))}
                <div style={{ display: "flex", justifyContent: "space-between", padding: "16px 0", fontWeight: 700, fontSize: 18 }}>
                  <span>Total:</span><span style={{ color: "#0026ff" }}>{totalCart} MDL</span>
                </div>
                <button style={{ ...styles.btn, width: "100%" }} onClick={() => { setShowCart(false); setShowOrder(true); }}>Plasează comanda</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ORDER MODAL */}
      {showOrder && (
        <div style={styles.modal} onClick={(e) => { if (e.target === e.currentTarget) setShowOrder(false); }}>
          <div style={styles.modalBox}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
              <h2 style={{ margin: 0 }}>📦 Plasează comanda</h2>
              <button style={{ ...styles.navBtn, fontSize: 18 }} onClick={() => setShowOrder(false)}>✕</button>
            </div>
            <div style={styles.formGroup}><label style={styles.label}>Nume complet *</label><input style={styles.input} value={orderForm.nume} onChange={(e) => setOrderForm({ ...orderForm, nume: e.target.value })} placeholder="Ion Popescu" /></div>
            <div style={styles.formGroup}><label style={styles.label}>Telefon *</label><input style={styles.input} value={orderForm.telefon} onChange={(e) => setOrderForm({ ...orderForm, telefon: e.target.value })} placeholder="+373 XX XXX XXX" /></div>
            <div style={styles.formGroup}><label style={styles.label}>Email</label><input style={styles.input} value={orderForm.email} onChange={(e) => setOrderForm({ ...orderForm, email: e.target.value })} placeholder="email@exemplu.com" /></div>
            <div style={styles.formGroup}><label style={styles.label}>Adresă livrare *</label><input style={styles.input} value={orderForm.adresa} onChange={(e) => setOrderForm({ ...orderForm, adresa: e.target.value })} placeholder="str. Exemplu 1, Chișinău" /></div>
            <button style={{ ...styles.btn, width: "100%" }} onClick={placeOrder}>✅ Confirmă comanda</button>
          </div>
        </div>
      )}

      {/* LOGIN MODAL */}
      {showLogin && (
        <div style={styles.modal} onClick={(e) => { if (e.target === e.currentTarget) setShowLogin(false); }}>
          <div style={styles.modalBox}>
            <h2 style={{ marginBottom: 20 }}>🔐 Admin</h2>
            <div style={{ display: "flex", marginBottom: 20, borderBottom: "1px solid #333" }}>
              <button onClick={() => setAuthTab("login")} style={{ flex: 1, padding: "10px", background: "none", border: "none", color: authTab === "login" ? "#0026ff" : "#666", borderBottom: authTab === "login" ? "2px solid #0026ff" : "none", cursor: "pointer", fontWeight: 600, fontSize: 14 }}>Login</button>
              <button onClick={() => setAuthTab("register")} style={{ flex: 1, padding: "10px", background: "none", border: "none", color: authTab === "register" ? "#0026ff" : "#666", borderBottom: authTab === "register" ? "2px solid #0026ff" : "none", cursor: "pointer", fontWeight: 600, fontSize: 14 }}>Înregistrare</button>
            </div>
            {authTab === "login" ? (
              <>
                <div style={styles.formGroup}><label style={styles.label}>Email</label><input style={styles.input} type="email" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} /></div>
                <div style={styles.formGroup}><label style={styles.label}>Parolă</label><input style={styles.input} type="password" value={loginPass} onChange={(e) => setLoginPass(e.target.value)} onKeyDown={(e) => e.key === "Enter" && login()} /></div>
                {loginErr && <p style={{ color: "#e74c3c", marginBottom: 12 }}>{loginErr}</p>}
                <button style={{ ...styles.btn, width: "100%" }} onClick={login}>Conectare</button>
              </>
            ) : (
              <>
                {regSuccess ? (
                  <div style={{ textAlign: "center", padding: 20 }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
                    <p style={{ color: "#4caf50", marginBottom: 8 }}>Cont creat cu succes!</p>
                    <p style={{ color: "#aaa", fontSize: 13 }}>Contul tău are status <b>pending</b>. Adminul trebuie să îți aprobe accesul.</p>
                  </div>
                ) : (
                  <>
                    <div style={styles.formGroup}><label style={styles.label}>Nume</label><input style={styles.input} value={regName} onChange={(e) => setRegName(e.target.value)} placeholder="Ion Popescu" /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Email</label><input style={styles.input} type="email" value={regEmail} onChange={(e) => setRegEmail(e.target.value)} /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Parolă</label><input style={styles.input} type="password" value={regPass} onChange={(e) => setRegPass(e.target.value)} /></div>
                    {regErr && <p style={{ color: "#e74c3c", marginBottom: 12 }}>{regErr}</p>}
                    <button style={{ ...styles.btn, width: "100%" }} onClick={register}>Creează cont</button>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* ADD/EDIT PRODUCT MODAL */}
      {showAddProduct && isAdmin && (
        <AddProductModal editProduct={editProduct} onClose={() => { setShowAddProduct(false); setEditProduct(null); }} db={db} />
      )}

      {/* FOOTER */}
      <footer style={styles.footer}>
        <div style={{ marginBottom: 8, color: "#0026ff", fontWeight: 700 }}>For Me Outlet</div>
        <div>Modă pentru tine</div>
        <div style={{ marginTop: 8 }}>📞 +373079797904 | ✉️ formeoutlet8@gmail.com | 📍 strada Miron Costin 2 a, Orhei</div>
        <div style={{ marginTop: 8 }}>🕐 luni-duminică 8:00-17:00</div>
        <div style={{ marginTop: 12, color: "#444" }}>© {new Date().getFullYear()} For Me Outlet. Toate drepturile rezervate.</div>
      </footer>
    </div>
  );
}

function AddProductModal({ editProduct, onClose, db }) {
  const [form, setForm] = useState({
    nume: editProduct?.nume || "",
    pret: editProduct?.pret || "",
    pretRedus: editProduct?.pretRedus || "",
    descriere: editProduct?.descriere || "",
    categorie: editProduct?.categorie || "",
    culori: editProduct?.culori || "",
    tipMarimi: editProduct?.tipMarimi || "haine",
  });
  const [imagini, setImagini] = useState(editProduct?.imagini || []);
  const [marimi, setMarimi] = useState(editProduct?.marimi || []);
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef();
  const [tempC1, setTempC1] = useState("#ffffff"); const [tempC2, setTempC2] = useState("#000000");

  const handleFiles = async (files) => {
    if (imagini.length >= 4) return;
    setUploading(true);
    const toUpload = Array.from(files).slice(0, 4 - imagini.length);
    const urls = [];
    for (const file of toUpload) {
      try { const url = await uploadToCloudinary(file); urls.push(url); } catch (e) { console.error(e); }
    }
    setImagini((prev) => [...prev, ...urls]);
    setUploading(false);
  };

  const toggleSize = (size) => {
    setMarimi((prev) => prev.includes(size) ? prev.filter((s) => s !== size) : [...prev, size]);
  };

   const save = async () => {
  if (!form.nume || !form.pret) return;
  const data = { ...form, pret: Number(form.pret), pretRedus: form.pretRedus ? Number(form.pretRedus) : null, imagini, marimi, createdAt: editProduct?.createdAt || new Date() };
  try {
    if (editProduct) { await updateDoc(doc(db, "produse", editProduct.id), data); }
    else { await addDoc(collection(db, "produse"), { ...data, createdAt: new Date() }); }
    onClose();
  } catch (e) {
    alert("Eroare: " + e.message);
  }
};

  const currentSizes = form.tipMarimi === "pantofi" ? SHOE_SIZES : CLOTH_SIZES;

  return (
    <div style={styles.modal} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={styles.modalBox}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <h2 style={{ margin: 0 }}>{editProduct ? "✏️ Editează produs" : "➕ Adaugă produs"}</h2>
          <button style={{ background: "none", border: "none", color: "#f0f0f0", cursor: "pointer", fontSize: 18 }} onClick={onClose}>✕</button>
        </div>

        {/* IMAGE UPLOAD */}
        <div style={{ marginBottom: 16 }}>
          <label style={styles.label}>Imagini (max 4) — calitate originală</label>
          <div
            style={{ border: `2px dashed ${dragOver ? "#0400ff" : "#333"}`, borderRadius: 10, padding: 24, textAlign: "center", cursor: "pointer", marginBottom: 12 }}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => { e.preventDefault(); setDragOver(false); handleFiles(e.dataTransfer.files); }}
            onClick={() => fileRef.current.click()}
          >
            {uploading ? <span style={{ color: "#940505" }}>⏳ Se uploadează...</span> : <span style={{ color: "#666" }}>📁 Trage imaginile aici sau apasă pentru a selecta</span>}
          </div>
          <input ref={fileRef} type="file" accept="image/*" multiple style={{ display: "none" }} onChange={(e) => handleFiles(e.target.files)} />
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {imagini.map((img, i) => (
              <div key={i} style={{ position: "relative" }}>
                <img src={img} alt="" style={{ width: 70, height: 70, objectFit: "cover", borderRadius: 8 }} />
                <button onClick={() => setImagini((prev) => prev.filter((_, j) => j !== i))} style={{ position: "absolute", top: -6, right: -6, background: "#c0392b", border: "none", borderRadius: "50%", width: 20, height: 20, color: "#fff", cursor: "pointer", fontSize: 12 }}>✕</button>
              </div>
            ))}
          </div>
        </div>

        <div style={styles.formGroup}><label style={styles.label}>Nume produs *</label><input style={styles.input} value={form.nume} onChange={(e) => setForm({ ...form, nume: e.target.value })} placeholder="Rochie elegantă" /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
          <div><label style={styles.label}>Preț (MDL) *</label><input style={styles.input} type="number" value={form.pret} onChange={(e) => setForm({ ...form, pret: e.target.value })} placeholder="450" /></div>
          <div><label style={styles.label}>Preț redus (MDL)</label><input style={styles.input} type="number" value={form.pretRedus} onChange={(e) => setForm({ ...form, pretRedus: e.target.value })} placeholder="350" /></div>
        </div>
        <div style={styles.formGroup}><label style={styles.label}>Categorie</label><input style={styles.input} value={form.categorie} onChange={(e) => setForm({ ...form, categorie: e.target.value })} placeholder="rochii, bluze, pantofi..." /></div>

        {/* SIZES */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Tip mărimi</label>
          <select style={styles.input} value={form.tipMarimi} onChange={(e) => { setForm({ ...form, tipMarimi: e.target.value }); setMarimi([]); }}>
            <option value="haine">Haine (XS-XXL)</option>
            <option value="pantofi">Pantofi (EU 34-46)</option>
          </select>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Mărimi disponibile</label>
          <div>
            {currentSizes.map((s) => (
              <button key={s} style={{ ...styles.sizeBtn, ...(marimi.includes(s) ? styles.sizeBtnActive : {}) }} onClick={() => toggleSize(s)}>{s}</button>
            ))}
          </div>
        </div>
       <div style={styles.formGroup}><label style={styles.label}>Culori disponibile</label><div style={{display:"flex",flexWrap:"wrap",gap:8,alignItems:"center"}}>{(form.culori?form.culori.split(",").filter(Boolean):[]).map((c,i)=>{const p=c.split("|");const bg=p.length>1?`linear-gradient(90deg,${p[0]} 50%,${p[1]} 50%)`:p[0];return(<div key={i} style={{width:32,height:32,borderRadius:"50%",background:bg,border:"2px solid #555",cursor:"pointer"}} onClick={()=>setForm({...form,culori:form.culori.split(",").filter((_,idx)=>idx!==i).join(",")})} />);})}<div style={{display:"flex",gap:4,alignItems:"center"}}><input type="color" value={tempC1} onChange={(e)=>setTempC1(e.target.value)} style={{width:28,height:28,cursor:"pointer",border:"none"}} /><input type="color" value={tempC2} onChange={(e)=>setTempC2(e.target.value)} style={{width:28,height:28,cursor:"pointer",border:"none"}} /><button type="button" onClick={()=>{const ex=form.culori?form.culori.split(",").filter(Boolean):[];setForm({...form,culori:[...ex,tempC1].join(",")});}} style={{fontSize:14,padding:"2px 8px",cursor:"pointer",borderRadius:4}}>+1</button><button type="button" onClick={()=>{const ex=form.culori?form.culori.split(",").filter(Boolean):[];const combo=tempC1+"|"+tempC2;setForm({...form,culori:[...ex,combo].join(",")});}} style={{fontSize:14,padding:"2px 8px",cursor:"pointer",borderRadius:4}}>+2</button></div></div></div>

        <button style={{ ...styles.btn, width: "100%" }} onClick={save}>💾 {editProduct ? "Salvează modificările" : "Adaugă produsul"}</button>
      </div>
    </div>
  );
}
